<template>
  <div class="columns is-centered">
    <div class="column is-3">
      <div class="title">Estás preparando</div>
      <div class="subtitle">{{ subTitle }}</div>
    </div>
    <div class="column is-1 is-hidden-mobile">
      <figure class="image image-border">
        <img :src="srcImagen" @error="imageUrlAlt"/>
      </figure>
    </div>
  </div>
</template>

<style>
.image-border {
  box-shadow: 0 0.5em 1em -0.125em grey, 0 0px 0 1px grey;
}
</style>

<script>
import ImagenPorDefecto from '@/assets/img/productos/default.png'

export default {
  name: 'TitleSlot',
  props: {
    tipoSubida: {
      type: String
    },
    oferta: {
      type: Object
    },
    packFoto: {
      type: Object
    }
  },
  computed: {
    srcImagen () {
      let src = ''
      if (this.tipoSubida) {
        switch (this.tipoSubida) {
          case this.$constantes.tiposSubida.PACK_FOTO:
            src = this.packFoto.oferta.imagenUrl
            break
          case this.$constantes.tiposSubida.OFERTA:
            src = this.oferta.imagenUrl
            break
        }
      }
      return src
    },
    subTitle () {
      let subTitle = ''
      if (this.tipoSubida) {
        switch (this.tipoSubida) {
          case this.$constantes.tiposSubida.PACK_FOTO:
            subTitle = this.packFoto.oferta.nombreCompleto
            break
          case this.$constantes.tiposSubida.OFERTA:
            subTitle = this.oferta.nombreCompleto
            break
        }
      }
      return subTitle
    }
  },
  methods: {
    imageUrlAlt (event) {
      event.target.src = ImagenPorDefecto
    }
  }
}
</script>
